import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">分类导航</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">快速找到你想要的91视频、97视频、51视频内容分类</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardsData.map((card) => {
            const isPrimary = card.color === 'primary';
            return (
              <a
                key={card.id}
                href="#cards"
                onClick={(e) => e.preventDefault()}
                className="group flex items-start gap-4 p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-200/40 transition-all duration-300 cursor-pointer"
              >
                <div
                  className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors ${
                    isPrimary
                      ? 'bg-primary-100 group-hover:bg-primary-200'
                      : 'bg-accent-100 group-hover:bg-accent-200'
                  }`}
                >
                  <i className={`${card.icon} ${isPrimary ? 'text-primary-600' : 'text-accent-600'} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-semibold font-heading text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
                </div>
              </a>
            );
          })}
          <a
            href="#cards"
            onClick={(e) => e.preventDefault()}
            className="flex items-center justify-center gap-2 p-5 md:p-6 rounded-2xl bg-background-50 border border-dashed border-background-300/60 hover:border-primary-300/50 hover:bg-background-100/80 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-add-line text-foreground-400 text-lg"></i>
            <span className="text-sm text-foreground-400">更多分类即将上线</span>
          </a>
        </div>
      </div>
    </section>
  );
}